import { isEmpty } from "lodash";
import React from "react";
import Location from "../../assets/images/bx-location-plus.svg";
import RemoteWork from "../../assets/images/remoteWork.png";
import JobTypes from "../../assets/images/jobTypes.png";
import "../../css/profileCompletionJourney.css";

type PropTypes = {
  isRemote: boolean;
  locationAddress: string | undefined;
  selectedJobTypes: Array<string>;
};

function DesiredJobTypeMap(props: PropTypes) {
  const { isRemote, locationAddress, selectedJobTypes } = props;

  return (
    <div style={{ paddingLeft: "20px" }}>
      {!isEmpty(locationAddress) && (
        <div className="profile_completion_item_section">
          <img
            src={Location}
            style={{ height: "50px", width: "20px", marginRight: "28px" }}
          />
          <div className="flex_column_align_center">
            <text className="profile_completion_item_heading">
              My desired location is{" "}
            </text>
            <text className="profile_completion_item_text">
              {locationAddress}
            </text>
          </div>
        </div>
      )}
      {isRemote && (
        <div
          className="profile_completion_item_section"
          style={{ paddingLeft: "4px" }}
        >
          <img src={RemoteWork} style={{ height: "40px", width: "40px" }} />
          <div
            className="flex_column_align_center"
            style={{ marginLeft: "17px" }}
          >
            <text className="profile_completion_item_text">
              I am open for remote work{" "}
            </text>
          </div>
        </div>
      )}
      {!isEmpty(selectedJobTypes) && (
        <div className="profile_completion_item_section">
          <img src={JobTypes} style={{ height: "30px", width: "30px" }} />
          <div
            className="flex_column_align_center"
            style={{ marginLeft: "20px" }}
          >
            <text className="profile_completion_item_heading">
              I am available{" "}
            </text>
            {selectedJobTypes.map((item) => (
              <text
                className="profile_completion_item_text"
                style={{ textAlign: "center" }}
              >
                {item}
              </text>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DesiredJobTypeMap;
